import React from "react";
import PropTypes from "prop-types";
import {
  setColourShadeIfMissing,
  SIGNOL_COLOUR_NAMES,
} from "@signolteam/shared/colours";
import AppUtils from "@src/utils/appUtils";

const SectionContainer = ({
  paddingX = 2,
  paddingY = 4,
  children,
  bgColor = undefined,
  shadow = true,
  gap = 4,
  borderColor,
  textColor,
  setSize,
}) => {
  const sizes = {
    onboarding: "h-auto sm:h-[540px] w-9/10 sm:w-[540px] min-h-[500px]",
  };
  const sizeClass = setSize ? sizes[setSize] : "";
  const bgClass = bgColor
    ? `bg-${setColourShadeIfMissing(bgColor, 300)}`
    : "bg-white";

  const gapClass = `flex flex-col gap-${gap}`;

  const shadowClass = shadow ? "shadow-md" : "";

  const borderClass = borderColor
    ? `border-1 border-${setColourShadeIfMissing(borderColor, 400)}`
    : "";

  const textClass = textColor
    ? `text-${setColourShadeIfMissing(textColor, 700)}`
    : "";

  return (
    <div
      className={`rounded-2xl px-${paddingX} py-${paddingY} ${bgClass} ${gapClass} ${shadowClass} ${borderClass} ${textClass} ${sizeClass}`}
    >
      {children}
    </div>
  );
};

export const sectionContainerControls = {
  children: {
    propType: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.string,
    ]),
    description: "Card content",
    disable: true,
  },
  shadow: {
    propType: PropTypes.bool,
    description: "Enable card shadow",
    controlType: "boolean",
    defaultValue: false,
  },
  bgColor: {
    propType: PropTypes.string,
    controlType: "select",
    options: SIGNOL_COLOUR_NAMES,
    description: "Background colour",
  },
  gap: {
    propTypes: PropTypes.number,
    controlType: "select",
    options: [0, 2, 4, 8],
    description: "Gap between elements in the section",
  },
  paddingX: {
    propTypes: PropTypes.number,
    controlType: "select",
    options: [0, 2, 4, 8],
    description: "Padding on x axis to replace the default px-2",
  },
  paddingY: {
    propTypes: PropTypes.number,
    controlType: "select",
    options: [0, 2, 4, 8],
    description: "Padding on y axis to replace the default py-4",
  },
};

SectionContainer.propTypes = AppUtils.getPropTypeFromControls(
  sectionContainerControls,
);

export default SectionContainer;
